// hooks/useChatComposeResize.js
import { useState, useRef, useEffect } from "react"

const STORAGE_KEY = "chat-compose-height"
const MIN_HEIGHT = 120
const MAX_HEIGHT = 600
const DEFAULT_HEIGHT = 200

const useChatComposeResize = (initialHeight = DEFAULT_HEIGHT) => {
  const [composeHeight, setComposeHeight] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY)
    return saved ? parseFloat(saved) : initialHeight
  })

  const isResizingRef = useRef(false)

  useEffect(() => {
    if (composeHeight > 0) {
      localStorage.setItem(STORAGE_KEY, composeHeight)
    }
  }, [composeHeight])

  const startResizeCompose = (e) => {
    e.preventDefault()
    isResizingRef.current = true

    const startY = e.clientY
    const startHeight = composeHeight

    const onMove = (e) => {
      if (!isResizingRef.current) return
      const delta = startY - e.clientY
      const newHeight = Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, startHeight + delta))
      setComposeHeight(newHeight)
    }

    const onUp = () => {
      isResizingRef.current = false
      document.removeEventListener("mousemove", onMove)
      document.removeEventListener("mouseup", onUp)
    }

    document.addEventListener("mousemove", onMove)
    document.addEventListener("mouseup", onUp)
  }

  return {
    composeHeight,
    setComposeHeight,
    isResizingCompose: isResizingRef.current,
    startResizeCompose,
  }
}

export default useChatComposeResize
